export default __webpack_public_path__ + "static/media/snarerim.100df0c0.mp3";